module.exports = __webpack_public_path__ + "img/ewh-4.23a9bfef.png";